import React, { useContext } from "react";
import { SystemContext } from "../context/SystemContext";
import DismissableBanner from "./DismissableBanner";

const COOKIE_NAME = "headerBannerClosed";

const HeaderBanner = () => {
  const { shipmentSettings } = useContext(SystemContext);

  return (
    <DismissableBanner cookieName={COOKIE_NAME}>
      {shipmentSettings?.freeShipmentThreshold ? <div>{`Free Shipping Over $${shipmentSettings?.freeShipmentThreshold}`}</div> : null}
    </DismissableBanner>
  );
};

export default HeaderBanner;
